const isVisible = ref<boolean>(false);

export function useCheckoutModal() {
  const showCheckout = (state?: boolean): void => {
    if (!import.meta.client) {
      return;
    }
    isVisible.value = typeof state === 'boolean' ? state : !isVisible.value;

    isVisible.value
      ? document.body.classList.add('overflow-hidden')
      : document.body.classList.remove('overflow-hidden');
  };

  return {
    isVisible,
    showCheckout,
  };
}
